
import { Options, Vue } from 'vue-class-component';
import WelcomeForm from "@/views/WelcomeForm.vue";
import SearchForm from "@/views/SearchForm.vue";
import ResultsForm from "@/views/ResultsForm.vue";

import '@vuepic/vue-datepicker/dist/main.css'
import '@vueform/slider/themes/default.css'
import '@/assets/style.scss'

import {Tour} from "@/Tour";
import countries from "@/data/contries.json"
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap"
import Hotel from "@/Hotels";
import {SearchParams} from "@/services/tours";
import {Prop} from "vue-property-decorator";

@Options({
    components: {
      WelcomeForm,
      SearchForm,
      ResultsForm,
    },
})
export default class App extends Vue {

    @Prop({required: false})
    url!: string;

    message = "";
    tours: Tour[] | null = null;
    hotels: Hotel[] | null = null;
    search_data: SearchParams | null = null;

    mounted(){
      const searchParams = new URL(window.location.href).searchParams;
      const from = searchParams.get("from");
      const date = searchParams.get("date");
      const adults = searchParams.get("adults");
      const nights = searchParams.get("nights");

      if(from && date && adults && nights){
        const paths = window.location.pathname.split('/').filter((item)=>item);
        const to_object = countries.find(item=>{
          return item.code === paths[paths.length -1];
        })

        if(to_object){
          this.search_data = {
            from,
            to: to_object.label,
            start_date: new Date(+date),
            nights_count: +nights,
            adults_count: +adults
          }
        }
      }
    }

    onFormSubmit(object: SearchParams){
      if(process.env.NODE_ENV === "developmentt"){
        this.search_data = object;
      }else{
        const params = new URLSearchParams();
        const to_object = countries.find(item=>{
          return item.label === object.to;
        })

        if(to_object){
          params.append("from",object.from);
          params.append("date",(+object.start_date).toString());
          params.append("nights", object.nights_count.toString());
          params.append("adults", object.adults_count.toString());
          window.location.href = `/tours/beach-tours/${to_object.code}/?` + params.toString()
        }
      }
    }
}
